import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=8517f9e4&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Fields.vue?vue&type=style&index=0&id=8517f9e4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8517f9e4",
  null
  ,true
)

export default component.exports